// extracted by mini-css-extract-plugin
module.exports = {"inspectorTabPanel":"style__inspectorTabPanel___2z7Yl"};